var _a, _b;
import './style.css';
import * as THREE from 'three';
import { OrbitControls } from './OrbitControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
import gsap from 'gsap';
const canvas = document.querySelector('canvas.webgl');
const btn320 = document.getElementById('Yar320');
const btn500 = document.getElementById('Yar500');
let activeModel;
const contentWindow = document.querySelector('.window');
btn320.disabled = true;
btn500.disabled = true;
const scene = new THREE.Scene();
scene.background = new THREE.Color("#FDF5E6");
let startCameraAnimation = false;
let startCameraRotation = false;
let rotationSpeed = 0.001;
let stopCameraRotation = false;
const intersectObjects = [];
const intersectCollider = [];
let currentIntersect;
let labelRenderer;
const mouse = new THREE.Vector2(1, 1);
const startPositionY = {
    'Квартал__<Гжель>': 0,
};
const yarmarka500 = {
    gjel: {
        name: 'Гжель',
        colider: 'gjelCollider',
        object: 'gjelObj'
    },
    sib: {
        name: 'Сибирский',
        colider: 'sibCollider',
        object: 'sibObj'
    },
    dal: {
        name: 'Дальневосточный',
        colider: 'dalCollider',
        object: 'dalObj'
    },
    xoxloma: {
        name: 'Хохлома',
        colider: 'xoxlomaCollider',
        object: 'xoxlomaObj'
    },
    asia: {
        name: 'Восточный',
        colider: 'asiaCollider',
        object: 'asiaObj'
    },
    mest: {
        name: 'местного народа',
        colider: 'mestCollider',
        object: 'mestObj'
    },
};
const yarmarka320 = {
    mest: {
        name: 'местного народа',
        colider: 'mestCollider',
        object: 'mestObj'
    },
    sib: {
        name: 'Сибирский',
        colider: 'sibCollider',
        object: 'sibObj'
    },
    dal: {
        name: 'Дальневосточный',
        colider: 'dalCollider',
        object: 'dalObj'
    },
    xoxloma: {
        name: 'Хохлома',
        colider: 'xoxlomaCollider',
        object: 'xoxlomaObj'
    },
    asia: {
        name: 'Восточный',
        colider: 'asiaCollider',
        object: 'asiaObj'
    },
};
const preloaderLinearFill = document.getElementById("preloader-linear-fill");
const preloader = document.getElementById("preloader-scene");
let maxWidth = 195;
const gltfLoader = new GLTFLoader();
const loadModel = (model, modelObj, name) => {
    preloader.style.display = "flex";
    clearScene(scene);
    gltfLoader.load(model, (gltf) => {
        if (name === '320') {
            btn320.disabled = true;
            btn500.disabled = false;
        }
        else if (name === '500') {
            btn320.disabled = false;
            btn500.disabled = true;
        }
        preloader.style.display = "none";
        camera.position.y = CAMERASTARTPOSITION.x;
        camera.position.x = CAMERASTARTPOSITION.y;
        camera.position.z = CAMERASTARTPOSITION.z;
        startCameraAnimation = true;
        Object.keys(modelObj).forEach((key) => {
            gltf.scene.children.forEach((obj) => {
                if (obj.name === modelObj[key].object) {
                    startPositionY[obj.name] = obj.position.y;
                    intersectObjects.push(obj);
                }
                if (obj.name === modelObj[key].colider) {
                    let mesh = obj;
                    mesh.userData.objTitle = modelObj[key].name;
                    mesh.userData.objName = modelObj[key].object;
                    mesh.visible = false;
                    mesh.material = new THREE.MeshStandardMaterial({ transparent: true, opacity: 0, });
                    intersectCollider.push(mesh);
                }
            });
        });
        intersectCollider.forEach((obj) => {
            const colliderObject = intersectObjects.find((intersectObject) => intersectObject.name === obj.userData.objName);
            obj.userData.obj = colliderObject;
        });
        scene.add(gltf.scene);
    }, (progress) => {
        preloaderLinearFill.style.width = (progress.loaded * maxWidth) / progress.total + "px";
    });
};
loadModel('yar320-v10new.glb', yarmarka320, '320');
// loadModel('yar320-v11.glb', yarmarka320, '320');
btn320 === null || btn320 === void 0 ? void 0 : btn320.addEventListener('click', () => {
    btn500 === null || btn500 === void 0 ? void 0 : btn500.classList.remove('active');
    btn320 === null || btn320 === void 0 ? void 0 : btn320.classList.add('active');
    loadModel('yar320-v10new.glb', yarmarka320, '320');
});
btn500 === null || btn500 === void 0 ? void 0 : btn500.addEventListener('click', () => {
    btn320 === null || btn320 === void 0 ? void 0 : btn320.classList.remove('active');
    btn500 === null || btn500 === void 0 ? void 0 : btn500.classList.add('active');
    loadModel('Yarmarka_500v7.glb', yarmarka500, '500');
});
const labelWrapper = document.createElement('div');
labelWrapper.innerHTML = `
  <svg width="200" height="100" viewBox="0 0 833 207" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d)">
  <path d="M758.9 194H113.3C77.6 194 48.4 164.8 48.4 129.1V91.6C48.4 55.9 77.6 26.7 113.3 26.7H758.9C794.6 26.7 823.8 55.9 823.8 91.6V129.1C823.8 164.8 794.6 194 758.9 194Z" fill="white"/>
  </g>
  <path d="M154.4 86.5C149.8 11.5 102.5 0.900024 77.4 0.400024C52.2 0.900024 5 11.6 0.399995 86.5C-4.2 161.5 77.4 206.6 77.4 206.6C77.4 206.6 159.1 161.5 154.4 86.5Z" fill="#E73539"/>
  <text transform="matrix(1 0 0 1 180 94)"><tspan x="0" y="0" class="st1 st2 st3">квартал </tspan><tspan id="label-title" x="0" y="62.6" class="st1 st2 st3"></tspan></text>
  <path d="M78.6 117.6C97.3777 117.6 112.6 102.378 112.6 83.6C112.6 64.8224 97.3777 49.6 78.6 49.6C59.8223 49.6 44.6 64.8224 44.6 83.6C44.6 102.378 59.8223 117.6 78.6 117.6Z" fill="white"/>
  <defs>
  <filter id="filter0_d" x="47.4" y="25.7" width="785.4" height="177.3" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
  <feOffset dx="4" dy="4"/>
  <feGaussianBlur stdDeviation="2.5"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
  </filter>
  </defs>
  </svg>
`;
const labelTitle = labelWrapper.querySelector('#label-title');
const infoLabel = new CSS2DObject(labelWrapper);
infoLabel.position.set(0, 3, 0);
const raycaster = new THREE.Raycaster();
// const sizes = {
//   width: window.innerWidth,
//   height: window.innerHeight
// }
const sizes = {
    width: (_a = canvas === null || canvas === void 0 ? void 0 : canvas.parentElement) === null || _a === void 0 ? void 0 : _a.clientWidth,
    height: (_b = canvas === null || canvas === void 0 ? void 0 : canvas.parentElement) === null || _b === void 0 ? void 0 : _b.clientHeight
};
// window.addEventListener('resize', () => {
//   sizes.width = window.innerWidth;
//   sizes.height = window.innerHeight;
//   camera.aspect = sizes.width / sizes.height;
//   camera.updateProjectionMatrix();
//   renderer.setSize(sizes.width, sizes.height);
//   labelRenderer.setSize(sizes.width, sizes.height);
//   renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
// })
window.addEventListener('resize', () => {
    var _a, _b;
    sizes.width = (_a = canvas === null || canvas === void 0 ? void 0 : canvas.parentElement) === null || _a === void 0 ? void 0 : _a.clientWidth;
    sizes.height = (_b = canvas === null || canvas === void 0 ? void 0 : canvas.parentElement) === null || _b === void 0 ? void 0 : _b.clientHeight;
    if (sizes.width && sizes.height) {
        camera.aspect = sizes.width / sizes.height;
        camera.updateProjectionMatrix();
        renderer.setSize(sizes.width, sizes.height);
        labelRenderer.setSize(sizes.width, sizes.height);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    }
});
// window.addEventListener('mousemove', (event) => {
//   mouse.x = event.clientX / sizes.width! * 2 - 1;
//   mouse.y = - (event.clientY / sizes.height!) * 2 + 1;
// });
window.addEventListener('mousemove', (event) => {
    mouse.x = (event.clientX - canvas.getBoundingClientRect().x) / sizes.width * 2 - 1;
    mouse.y = -(event.clientY - canvas.getBoundingClientRect().y) / sizes.height * 2 + 1;
});
const up = (obj, dir) => {
    const tween = gsap.to(obj.position, { duration: 1, y: dir ? 10 : startPositionY[obj.name], ease: 'power3', paused: true });
    tween.play();
};
const CAMERASTARTPOSITION = { x: 500, y: 30, z: 800 };
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 10000);
camera.position.y = CAMERASTARTPOSITION.x;
camera.position.x = CAMERASTARTPOSITION.y;
camera.position.z = CAMERASTARTPOSITION.z;
scene.add(camera);
const dirLight = new THREE.DirectionalLight(0xffffff, 1.1);
dirLight.position.set(150, 100, 200);
scene.add(dirLight);
const hemiLight = new THREE.AmbientLight(0xffffff, 0.7);
scene.add(hemiLight);
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.outputEncoding = THREE.sRGBEncoding;
labelRenderer = new CSS2DRenderer();
labelRenderer.setSize(sizes.width, sizes.height);
labelRenderer.domElement.style.position = "absolute";
labelRenderer.domElement.style.bottom = "0px";
labelRenderer.domElement.style.right = "0px";
// document.body.appendChild(labelRenderer.domElement);
contentWindow === null || contentWindow === void 0 ? void 0 : contentWindow.append(labelRenderer.domElement);
const controls = new OrbitControls(camera, labelRenderer.domElement);
controls.enableDamping = true;
controls.dampingFactor = 0.05;
controls.minPolarAngle = Math.PI / 2.0 / 2 / 2;
controls.maxPolarAngle = Math.PI / 2;
controls.minDistance = 100;
controls.maxDistance = 600;
const tick = () => {
    if (startCameraAnimation) {
        camera.position.x -= 1.8;
        camera.position.y -= 2;
        camera.position.z -= 5;
        if (camera.position.z < 0) {
            startCameraAnimation = false;
            startCameraRotation = true;
        }
    }
    if (startCameraRotation) {
        if (!stopCameraRotation) {
            scene.children[3].rotation.y += rotationSpeed;
        }
        else {
            rotationSpeed -= 0.00002;
            if (rotationSpeed < 0) {
                startCameraRotation = false;
            }
            else {
                scene.children[3].rotation.y += rotationSpeed;
            }
        }
    }
    raycaster.setFromCamera(mouse, camera);
    if (intersectCollider.length > 0) {
        const intersects = raycaster.intersectObjects(intersectCollider, true);
        if (intersects.length) {
            stopCameraRotation = true;
            if ((currentIntersect === null || currentIntersect === void 0 ? void 0 : currentIntersect.name) !== intersects[0].object.name) {
                if (currentIntersect) {
                    up(currentIntersect.userData.obj, false);
                }
                currentIntersect = null;
            }
            if (!currentIntersect) {
                // console.log('mouse enter');
                up(intersects[0].object.userData.obj, true);
                labelTitle.textContent = intersects[0].object.userData.objTitle;
                intersects[0].object.add(infoLabel);
            }
            currentIntersect = intersects[0].object;
        }
        else {
            if (currentIntersect) {
                // console.log('mouse leave');
                up(currentIntersect.userData.obj, false);
                currentIntersect.remove(infoLabel);
            }
            currentIntersect = null;
        }
    }
    controls.update();
    renderer.render(scene, camera);
    labelRenderer.render(scene, camera);
    window.requestAnimationFrame(tick);
};
tick();
function clearScene(scene) {
    mouse.x = -10;
    mouse.y = -10;
    btn320.disabled = true;
    btn500.disabled = true;
    startCameraAnimation = false;
    startCameraRotation = false;
    stopCameraRotation = false;
    let meshes = scene.children.filter((child) => child.type === "Group");
    scene.remove(...meshes);
    intersectObjects.length = 0;
    intersectCollider.length = 0;
    if (currentIntersect) {
        currentIntersect.remove(infoLabel);
    }
    currentIntersect = null;
    rotationSpeed = 0.001;
}
